import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { UserApplicationForm, UserForm } from '../../models/forms/user-form';
import { UserFormService } from '../../services/user-form.service';
import { Application } from '../../models/application';

@Component({
    selector: 'app-user-app-selector',
    templateUrl: './user-app-selector.component.html',
    styleUrls: ['./user-app-selector.component.sass'],
    standalone: false
})
export class UserAppSelectorComponent {
  @Input() userForm!: FormGroup<UserForm>;
  @Input() availableApplications: Application[] = [];

  get applications(): FormArray<FormGroup<UserApplicationForm>> {
    return this.userForm.get('applications') as FormArray<FormGroup<UserApplicationForm>>;
  }

  get selectedApplications(): string[] {
    return (this.userForm.get('applications') as FormArray<FormGroup<UserApplicationForm>>)
      .value
      .filter(a => a.applicationId != null)
      .map(a => a.applicationId!);
  }

  constructor(private userFormService: UserFormService) { }

  addApplicationEntry(): void {
    this.applications.push(this.userFormService.createUserApplicationForm());
  }

  removeApplicationEntry(idx: number): void {
    this.applications.removeAt(idx);
  }
}